module.exports = __webpack_public_path__ + "edf778f9877b6cf1cb414d0c6c711d9a.svg";